export default class StringRenderer {

    static userRenderer (user) {
        return user.firstname + ' ' + user.name
    }

    static bandRenderer (band) {
        return band.name
    }
}